import React from "react";
import HEADER from "../header/Header.component";
import FOOTER from "../footer/Footer.component";
import { IGridLayoutProps } from "./Layout.types";
import { Col, Row } from "react-bootstrap";
import LayoutStyles from "./Layout.styles";
import PAGE_HEADING from "../page/page-heading/PageHeading.component";
import PAGINATION from "../page/pagination/Pagination.component";
import { useSelector } from "react-redux";
import { RootState } from "../../state-management/root-reducer";
import { isMobile } from "react-device-detect";
import PAGE_CONTROLS from "../page/page-controls/PageControls.component";

const GRID_LAYOUT: React.FC<IGridLayoutProps> = (props: IGridLayoutProps) => {
  const { children, isLoading, isFetching } = props;

  // App State
  const { totalCount } = useSelector((state: RootState) => state.pagination);

  return (
    <>
      <HEADER />

      <LayoutStyles.GridContainer
        className="grid-container projects-view g-4"
        fluid="xl"
      >
        <Row>
          <Col xs={12}>
            <PAGE_HEADING />
          </Col>
        </Row>

        <Row className="page-controls-row">
          <Col xs={12}>
            <PAGE_CONTROLS />
          </Col>
        </Row>

        <Row xs={1} sm={1} md={2} lg={3} className="content-row">
          {children}
        </Row>
      </LayoutStyles.GridContainer>

      {
        /* istanbul ignore next */ !isLoading &&
          !isFetching &&
          totalCount > 0 && (
            <PAGINATION size={isMobile ? "sm" : "lg"} totalCount={totalCount} />
          )
      }
      <FOOTER />
    </>
  );
};
export default GRID_LAYOUT;
